import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import PageHeader from "@saleor/components/PageHeader";
import { sectionNames } from "@saleor/intl";
import { ListActions, PageListProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import { SiteLanguageList_siteLanguages_edges_node } from "../../types/SiteLanguageList";
import SiteLanguageList from "../SiteLanguageList";

export interface SiteLanguagePageProps extends PageListProps, ListActions {
  siteLanguages: SiteLanguageList_siteLanguages_edges_node[];
  onBack: () => void;
}

const SiteLanguageListPage: React.FC<SiteLanguagePageProps> = ({
  onAdd,
  onBack,
  ...listProps
}) => {
  const intl = useIntl();

  return (
    <Container>
      <AppHeader onBack={onBack}>
        {intl.formatMessage(sectionNames.configuration)}
      </AppHeader>
      <PageHeader
        title={intl.formatMessage(sectionNames.siteLanguages)}
      ></PageHeader>
      <SiteLanguageList {...listProps} />
    </Container>
  );
};
SiteLanguageListPage.displayName = "SiteLanguageListPage";
export default SiteLanguageListPage;
